<template>
  <div class="app ltr landing-page horizontal">
    <LandingHeader />
    <LandingNavbar />

    <main class="container py-6" v-if="project">

      <!-- TITRE -->
      <div class="row mb-4">
        <div class="col">
          <h1 class="fw-bold">{{ project.title }}</h1>
          <span class="badge bg-primary me-2">{{ project.axis }}</span>
          <span class="badge bg-secondary">{{ formatStatus(project.status) }}</span>
        </div>
      </div>

      <!-- IMAGE + INFOS -->
      <div class="row mb-5">
        <div class="col-lg-6">
          <img
              :src="project.image"
              class="img-fluid rounded shadow-sm"
              alt="Projet CNTIPPEE"
          />
        </div>

        <div class="col-lg-6">
          <ul class="list-group list-group-flush">
            <li class="list-group-item">
              📍 <strong>Province :</strong> {{ project.province }}
            </li>
            <li class="list-group-item">
              💰 <strong>Budget :</strong> {{ formatCurrency(project.budget) }}
            </li>
            <li class="list-group-item">
              📅 <strong>Période :</strong>
              {{ project.startDate }} → {{ project.endDate }}
            </li>
            <li class="list-group-item">
              🤝 <strong>Partenaires :</strong>
<!--              {{ project.partners.join(', ') }}-->
            </li>
          </ul>

          <div class="mt-4">
            <label class="fw-bold mb-1">Avancement</label>
            <div class="progress">
              <div
                  class="progress-bar"
                  :style="{ width: project.progress + '%' }"
              >
                {{ project.progress }}%
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- DESCRIPTION -->
      <div class="row mb-5">
        <div class="col">
          <h4 class="fw-bold">Description du projet</h4>
          <p>{{ project.description }}</p>
        </div>
      </div>

      <!-- OBJECTIFS -->
      <div class="row mb-5">
        <div class="col">
          <h4 class="fw-bold">Objectifs</h4>
          <ul>
            <li v-for="(obj, index) in project.objectives" :key="index">
              {{ obj }}
            </li>
          </ul>
        </div>
      </div>

      <!-- TIMELINE -->
      <div class="row mb-5" v-if="project.timeline?.length">
        <div class="col">
          <h4 class="fw-bold mb-4">Chronologie du projet</h4>

          <ul class="timeline">
            <li
                v-for="(step, index) in project.timeline"
                :key="index"
                :class="step.status.toLowerCase()"
            >
              <span class="timeline-date">{{ formatDate(step.date) }}</span>
              <h6 class="mb-1">{{ step.title }}</h6>
              <p class="text-muted small mb-0">
                {{ step.description }}
              </p>
            </li>
          </ul>
        </div>
      </div>


      <!-- RETOUR -->
      <div class="row">
        <div class="col">
          <router-link to="/projets" class="btn btn-outline-primary">
            ← Retour aux projets
          </router-link>
        </div>
      </div>

    </main>

    <LandingFooter />
  </div>
</template>

<script>



  import {projectsMock} from "../../../mocks/projects.mock";
  import LandingFooter from "../../../components/landing/LandingFooter.vue";
  import LandingNavbar from "../../../components/landing/LandingNavbar.vue";
  import LandingHeader from "../../../components/landing/LandingHeader.vue";

  export default {
    name: 'ProjectDetailPage',
    components: {LandingHeader, LandingNavbar, LandingFooter},
    data() {
      return {
        project: null
      }
    },
    mounted() {
      const projectId = parseInt(this.$route.params.id, 10)
      this.project = projectsMock.find(p => p.id === projectId)
    },
    methods: {
      formatDate(date) {
        return new Intl.DateTimeFormat('fr-FR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }).format(new Date(date))
      },
      formatStatus(status) {
        switch (status) {
          case 'EN_COURS':
            return 'En cours'
          case 'TERMINE':
            return 'Terminé'
          case 'EN_PREPARATION':
            return 'En préparation'
          default:
            return status
        }
      },
      formatCurrency(value) {
        return new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'XAF',
          maximumFractionDigits: 0
        }).format(value)
      }
    }
  }
</script>

<style scoped>
.timeline {
  list-style: none;
  padding-left: 0;
  border-left: 3px solid #e5e7eb;
}

.timeline li {
  padding: 1rem 1rem 1rem 2rem;
  position: relative;
  margin-bottom: 1rem;
}

.timeline li::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 18px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #cbd5f5;
}

/* États */
.timeline li.done::before {
  background: #22c55e;
}
.timeline li.current::before {
  background: #3b82f6;
}
.timeline li.pending::before {
  background: #9ca3af;
}

.timeline-date {
  font-size: 12px;
  color: #6b7280;
}
</style>

